// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import MapController from "./map_controller";
import ToggleController from "./toggle_controller";
import PageViewController from "./page_view_controller";
application.register("map", MapController);
application.register("toggle", ToggleController);
application.register("page-view", PageViewController);
